export default __webpack_public_path__ + "static/media/loader.69281ced.gif";